var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { border: "", size: "mini", data: _vm.datas }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              prop: "Member.Code",
              label: "客户编号",
              width: "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "Member.Name",
              fixed: "left",
              label: "姓名",
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "Member.Mobile", label: "手机号", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "Member.Sex", label: "性别", width: "60" }
          }),
          _c("el-table-column", {
            attrs: { prop: "Member.Birthday", label: "年龄", width: "60" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.format.getAgeByDateString(
                            _vm.format.dateFormat(scope.row.Member.Birthday)
                          )
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { prop: "Answer1", label: "问答1" } }),
          _c("el-table-column", { attrs: { prop: "Answer2", label: "问答2" } }),
          _c("el-table-column", { attrs: { prop: "Answer3", label: "问答3" } }),
          _c("el-table-column", { attrs: { prop: "Answer4", label: "问答4" } }),
          _c("el-table-column", { attrs: { prop: "Answer5", label: "问答5" } }),
          _c("el-table-column", { attrs: { prop: "Answer6", label: "问答6" } }),
          _c("el-table-column", { attrs: { prop: "Answer7", label: "问答7" } }),
          _c("el-table-column", { attrs: { prop: "Answer8", label: "问答8" } }),
          _c("el-table-column", {
            attrs: { prop: "Answer9", label: "问答9", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.Answer9_1) +
                        "/" +
                        _vm._s(scope.row.Answer9_2) +
                        "/" +
                        _vm._s(scope.row.Answer9_3) +
                        "/" +
                        _vm._s(scope.row.Answer9_4) +
                        "/" +
                        _vm._s(scope.row.Answer9_5) +
                        "/" +
                        _vm._s(scope.row.Answer9_6) +
                        "/" +
                        _vm._s(scope.row.Answer9_7) +
                        "/" +
                        _vm._s(scope.row.Answer9_8) +
                        "/" +
                        _vm._s(scope.row.Answer9_9) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "Answer10", label: "问答10" }
          }),
          _c("el-table-column", {
            attrs: { prop: "Answer11", label: "问答11" }
          }),
          _c("el-table-column", {
            attrs: { prop: "InsertTime", label: "自测时间", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.format.dateTimeFormat(scope.row.InsertTime)
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          background: "",
          "page-sizes": _vm.pageSizeList,
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
          "current-page": _vm.pageIndex
        },
        on: {
          "size-change": _vm.pageSizeChange,
          "current-change": _vm.pageCurrentChange,
          "update:currentPage": function($event) {
            _vm.pageIndex = $event
          },
          "update:current-page": function($event) {
            _vm.pageIndex = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }